import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AppDownload } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";
export var LoggedOutAppDownloadCTA = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MobileOnlyHorizontalLine, {}),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "pageHeaderSerifRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "AD1zFP",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Get the Faire wholesale app"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "cC9PSI",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Shop on the go, message brands, and track orders with the Faire app."
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "2x"
                    }),
                    /*#__PURE__*/ _jsx(AppDownload, {
                        loggedOut: true,
                        noModal: useViewport().isMobile
                    })
                ]
            })
        ]
    });
};
var Container = styled(Column).withConfig({
    componentId: "sc-a0950db5-0"
})([
    "",
    "{padding:",
    ";}",
    "{max-width:",
    ";padding:",
    ";}",
    "{padding:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing("3x"), responsiveMediaQueries.tabletAndAbove, getSpacing(400), getSpacing("4x", "8x", "8x", "10x"), responsiveMediaQueries.desktopAndAbove, getSpacing("3x", 96, "5x", 0));
var MobileOnlyHorizontalLine = styled(HorizontalLine).withConfig({
    componentId: "sc-a0950db5-1"
})([
    "",
    "{display:none;}"
], responsiveMediaQueries.tabletAndAbove);
